module.exports = __webpack_public_path__ + "img/1578.67104d50.jpg";